var _defs, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 586,
    viewBox: "0 0 586 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 293,
    r: 290,
    stroke: "#D6F2F4",
    strokeWidth: 10,
    strokeDasharray: "10 4"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "c2",
    mask: "url(#m1)",
    stroke: "#D6F2F4",
    pathLength: 17,
    strokeWidth: 7,
    fill: "transparent",
    strokeDasharray: "18 36",
    r: 290,
    cx: 293,
    cy: 293,
    transform: "rotate(-90 293 293)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWallet);
export default __webpack_public_path__ + "static/media/circle-wallet.e1c46be5b24f69bd2596b7353fc67e34.svg";
export { ForwardRef as ReactComponent };